import ScrollReveal from 'scrollreveal'
import scrollTo from '../common/scrollTo'

const Selectors = function (selectors = {}) {
  return Object.assign(
    {
      asId(selectorKey) {
        return `#${this[selectorKey]}`
      },
      asClass(selectorKey) {
        return `.${this[selectorKey]}`
      },
      asString(selectorKey) {
        return selectorKey.replace(/^(#|\.)/, '')
      },
    },
    selectors
  )
}

class AccordionTabs {
  constructor($el) {
    this.$el = $el
    this.$tabTriggers = this.$el.querySelectorAll('.js-tabs-trigger')
    this.$tabPanels = this.$el.querySelectorAll('.js-tabs-panel')
    this.$accordionTriggers = this.$el.querySelectorAll('.js-accordion-trigger')

    this.isAccordion = window.innerWidth < this.breakpoint
    this.tabTriggersLength = this.$tabTriggers.length
    this.accordionTriggersLength = this.$accordionTriggers.length
    this.breakpoint = 768
    this.selectedTab = 0
    this.prevSelectedTab = null

    this.bindEvents()
  }

  bindEvents() {
    const self = this
    const urlParams = new URLSearchParams(window.location.search)
    const selectedType = urlParams.get('type')

    this.$tabTriggers.forEach(($el, index) => {
      $el.index = index
      $el.addEventListener('click', this.handleClick.bind(self))

      if ($el.classList.contains('is-selected')) {
        this.selectedTab = index
      }

      if ($el.dataset.type === selectedType) {
        this.selectedTab = index
      }

      this.hide(index)
    })

    this.$accordionTriggers.forEach(($el, index) => {
      $el.index = index
      $el.addEventListener('click', this.handleClick.bind(self))

      if ($el.classList.contains('is-selected')) {
        this.selectedTab = index
      }

      if ($el.dataset.type === selectedType) {
        this.selectedTab = index
      }

      this.hide(index)
    })

    this.selectTab(this.selectedTab)
  }

  handleClick(e) {
    e.preventDefault()

    let closestTrigger = e.target.closest('.js-tabs-trigger')
    let closestTab = 0

    if (closestTrigger === null) {
      closestTrigger = e.target.closest('.js-accordion-trigger')
      closestTab = closestTrigger.closest('.js-tabs-panel')
      this.isAccordion = true
    } else {
      this.isAccordion = false
    }

    const targetIndex = closestTrigger.index !== null ? closestTrigger.index : closestTab.index

    if (targetIndex === this.selectedTab) {
      return
    }

    this.selectTab(targetIndex)
  }

  show(index) {
    if (!this.$tabPanels[index]) {
      return
    }

    this.$tabPanels[index].removeAttribute('tabindex')
    this.$tabTriggers[index].removeAttribute('tabindex')
    this.$tabTriggers[index].classList.add('is-selected')
    this.$tabTriggers[index].setAttribute('aria-selected', true)

    this.$accordionTriggers[index].setAttribute('aria-expanded', true)

    if (this.isAccordion) {
      scrollTo(this.$accordionTriggers[index], 50)
    }

    const $panelContent = this.$tabPanels[index].querySelector('.tabs-content')
    $panelContent.setAttribute('aria-hidden', false)
    $panelContent.classList.remove('is-closed')
    $panelContent.classList.add('is-opened')

    this.$tabPanels[index].classList.remove('is-closed')
    this.$tabPanels[index].classList.add('is-opened')

    ScrollReveal().sync()
    window.dispatchEvent(new Event('resize'))
  }

  hide(index) {
    this.$tabTriggers[index].classList.remove('is-selected')
    this.$tabTriggers[index].setAttribute('aria-selected', false)
    this.$tabTriggers[index].setAttribute('tabindex', -1)

    this.$accordionTriggers[index].setAttribute('aria-expanded', false)

    const $panelContent = this.$tabPanels[index].querySelector('.tabs-content')
    $panelContent.setAttribute('aria-hidden', true)
    $panelContent.classList.remove('is-opened')
    $panelContent.classList.add('is-closed')

    this.$tabPanels[index].classList.remove('is-opened')
    this.$tabPanels[index].classList.add('is-closed')
    this.$tabPanels[index].setAttribute('tabindex', -1)
  }

  selectTab(index) {
    if (index === null) {
      if (this.isAccordion) {
        return
      } else {
        index = 0
      }
    }

    if (this.$tabPanels[index] && !this.$tabPanels[index].classList.contains('is-closed')) {
      if (index === this.selectedTab) {
        this.selectedTab = null
      } else {
        this.selectedTab = null
        this.prevSelectedTab = index
      }

      this.hide(index)

      return
    }

    if (this.prevSelectedTab === null || !this.isAccordion) {
      this.$tabTriggers.forEach((_, i) => {
        if (i !== index) {
          this.hide(i)
        }
      })
    } else {
      this.hide(this.selectedTab)
    }

    this.prevSelectedTab = this.selectedTab
    this.selectedTab = index

    this.show(this.selectedTab)
  }
}

const SELECTORS = Selectors({
  tabs: 'js-tabs',
})

const props = {
  $tabs: document.querySelectorAll(SELECTORS.asClass('tabs')),
}

const fn = {
  init: () => {
    props.$tabs.forEach(($el) => {
      new AccordionTabs($el)
    })
  },
}

export default {
  can: () => props.$tabs.length,
  run: fn.init,
}
